var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 181 186.347656 C 181 186.347656 185.75 229.613281 186.75 250.28125 C 193.664063 251.613281 203 254.945313 203.664063 259.613281 C 209 261.6875 213.414063 260.535156 215 259.613281 C 217.25 244.195313 209 204.945313 221.664063 188.945313 C 234.332031 172.945313 266.332031 165.613281 274.332031 146.613281 C 281.761719 128.972656 273.09375 90.347656 278.222656 73.710938 C 278.496094 72.835938 277.394531 72.179688 276.734375 72.8125 C 258.949219 89.828125 258.335938 122.296875 252.332031 128.945313 C 243.082031 139.195313 206.082031 146.53125 188.332031 165.984375 C 182.308594 172.589844 181 186.347656 181 186.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 149.121094 34.472656 C 144.152344 65.867188 119.992188 221.390625 124.335938 250.28125 C 133.417969 251.863281 138.335938 266.28125 150 266.28125 C 161.667969 266.28125 166.585938 251.863281 175.667969 250.28125 C 180.007813 221.390625 155.847656 65.867188 150.878906 34.472656 C 150.722656 33.46875 149.277344 33.46875 149.121094 34.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 119 186.347656 C 119 186.347656 114.25 229.613281 113.25 250.28125 C 106.332031 251.613281 97 254.945313 96.332031 259.613281 C 91 261.6875 86.582031 260.535156 85 259.613281 C 82.75 244.195313 91 204.945313 78.332031 188.945313 C 65.667969 172.945313 33.667969 165.613281 25.667969 146.613281 C 18.238281 128.972656 26.90625 90.347656 21.777344 73.710938 C 21.503906 72.835938 22.601563 72.179688 23.265625 72.8125 C 41.050781 89.828125 41.664063 122.296875 47.667969 128.945313 C 56.917969 139.195313 93.917969 146.53125 111.664063 165.984375 C 117.691406 172.589844 119 186.347656 119 186.347656 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrute);
export default __webpack_public_path__ + "static/media/Brute.6cc125f467c7226034e80c1a59291fa2.svg";
export { ForwardRef as ReactComponent };